<div class="content">
  <div class="graphic">
      <canvas #lineChart id="myChartAnnual">{{ chart }}</canvas>
  </div>
</div>